module.exports = __webpack_public_path__ + "fonts/icomoon.fa265a89.ttf";